<template>
  <div class="home-action">
    <HomeActionBox :is-new-reservation="makeNew" />
    <HomeActionBox :is-new-reservation="!makeNew" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import HomeActionBox from '@/components/home/HomeActionBox.vue';

const makeNew = ref(true);
</script>


<style scoped lang="scss">
  .home-action {
    display: flex;
    align-content: flex-start;
    justify-content: space-around;
    flex-flow: row wrap;
  }
</style>
